import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { SharedModule } from 'src/app/_shared/shared.module';
import { DocumentViewerPage } from './document-viewer.page';
import { PhotoViewModalComponentModule } from 'src/app/_components/photo-view-modal/photo-view-modal.module';

const routes: Routes = [
  {
    path: '',
    component: DocumentViewerPage,
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    SharedModule,
    PhotoViewModalComponentModule,
  ],
  declarations: [DocumentViewerPage],
})
export class DocumentViewerModule {}
